import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";
import { InputWithIconContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageInput/atoms/InputWithIcon/styles";
import { ConsolePageInputContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageInput/styles";
import {
  ConsolePageSelectContainer,
  Select,
} from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageSelect/styles";
import { ToolbarContainer } from "@Console/components/molecules/DataTable/atoms/Toolbar/styles";

export const HelpDeskWaitingAgentTableSectionContainer = styled.section`
  display: flex;
  flex-direction: column;

  ${ToolbarContainer} {
    padding: 0 1rem;

    .MuiTablePagination-actions > .MuiButtonBase-root.MuiIconButton-root {
      height: 2rem;
      width: 2rem;
    }

    .MuiTablePagination-toolbar {
      min-height: 3rem;
    }
  }

  .MuiDataGrid-root
    .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)
    > .MuiDataGrid-cell {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: horizontal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  [data-field="open_ticket"] {
    padding-right: 0 !important;
    min-width: 70px !important;
    max-width: 70px !important;
  }
`;

export const HelpDeskWaitingAgentTableSectionTitle = styled.h3`
  all: unset;
  font: 600 1.125rem/1.406rem "Inter";
  color: ${({ theme }) => theme.console.pageTitleColor} !important;
`;

export const HelpDeskWaitingAgentTableSectionFilterContainer = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 1350px) {
    flex-wrap: wrap;

    .review-all-button-container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }

  ${ConsolePageButtonStyles} {
    padding: 0;
  }

  > div:first-child {
    display: flex;
    width: 100%;
    gap: 1rem;

    @media (max-width: 1000px) {
      display: grid;
      grid-template-columns: 1fr 1fr;

      ${InputWithIconContainer} {
        grid-column: 1/-1;
      }

      ${InputWithIconContainer}, ${ConsolePageSelectContainer} {
        max-width: initial;
        width: 100% !important;
      }
    }

    @media (max-width: 500px) {
      grid-template-columns: 1fr;
    }
  }

  ${InputWithIconContainer} {
    max-width: 250px;
  }

  ${ConsolePageInputContainer} > label {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font: 500 0.75rem/0.938rem "Inter";
  }

  ${Select} {
    height: 48px;
  }
`;
